import * as React from 'react';
import { UncontrolledCollapse } from 'reactstrap';

interface IModalLegalProps {
    which: string;
    first?: boolean;
    coverage: number;
}

export default function CollapseInformationExample(props: IModalLegalProps) {
  const { first = false } = props;

  return (
    <>
        <span className="accordion-button position-relative px-16 d-flex cursor-pointer justify-content-between align-content-center align-items-center" id={"example-" + Number(first)}>
            {first ? "Cuando tu Isapre o Fonasa cubre 50% o más " : "Cuando tu Isapre o Fonasa cubre menos del 50%"} y tienes un plan del 70% de reembolso.
            <i className="material-icons position-absolute">keyboard_arrow_down</i>
        </span>
        <UncontrolledCollapse toggler={"#example-" + Number(first)} className="w-100">
            <div className="modal-collapse-layout d-flex flex-column justify-content-center align-items-center align-content-center">
                <p className="modal-example-title px-16 m-0 p-0 mb-16">El reembolso se aplica sobre el {first ? "resto del valor que no cubre tu Isapre o Fonasa" : "50% del valor total de la prestación."} :</p>
                <div className="modal-example-value d-flex flex-column justify-content-center align-items-center align-content-center">
                    <p className="px-16 m-0">Si tu consulta médica es de:</p>
                    <h3 className="px-24 m-0 p-0">$60.000</h3>
                </div>
                <div className="modal-example-breaker d-flex justify-content-center align-items-center align-content-center">
                    <i className="px-40 material-icons">keyboard_arrow_down</i>
                </div>
                <div className="modal-example-value d-flex flex-column justify-content-center align-items-center align-content-center">
                    <p className="px-16 m-0">Y tu cobertura de Isapre o Fonasa es de, por ejemplo {first ? 60 : 40}%, normalmente pagarías:</p>
                    <h3 className="px-24 m-0 p-0">${(first ? "24" : "36") + ".000"}</h3>
                </div>
                <div className="modal-example-breaker d-flex justify-content-center align-items-center align-content-center">
                    <i className="px-40 material-icons">keyboard_arrow_down</i>
                </div>
                <div className="modal-example-value d-flex flex-column justify-content-center align-items-center align-content-center">
                    <p className="px-16 m-0">Pero luego del reembolso (70%) del seguro complementario pagarías</p>
                    <h3 className="px-24 m-0 p-0">${(first ? "7.200" : "9.000")}</h3>
                </div>
            </div>
        </UncontrolledCollapse>
    </>
  );
}
